import api from './index'

export default {
  login(credentials) {
    return api.post('/admin/auth/login', credentials)
  },
  logout() {
    return api.post('/admin/auth/logout')
  },
  getProfile() {
    return api.get('/admin/auth/profile')
  },
  updateProfile(data) {
    return api.put('/admin/auth/profile', data)
  }
}
